import { ResourceTypeEnum } from '@src/endpoints/services/commonHdr.service'
export * from './public.objects.columns.configuration'

export const PublicObjectNames = {
  [ResourceTypeEnum.INSTANCE]: 'Instances',
  [ResourceTypeEnum.OBJECT_STORE]: 'Object Stores',
  [ResourceTypeEnum.RELATIONAL_DB]: 'Relational DBs',
  [ResourceTypeEnum.SECURITY_GROUP]: 'Security Groups',
  [ResourceTypeEnum.SUBNET]: 'Subnets'
}
